/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineTip.vue?vue&type=template&id=4466ba5e&scoped=true"
import script from "./popMineTip.vue?vue&type=script&lang=js"
export * from "./popMineTip.vue?vue&type=script&lang=js"
import style0 from "./popMineTip.vue?vue&type=style&index=0&id=4466ba5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466ba5e",
  null
  
)

export default component.exports